import { shallowEqual } from 'react-redux';
import { Toast, Widget, WidgetEditor } from 'jamespot-front-business';
import jApi, { CombinedWidgetContent, WidgetDisplayMode } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import { commonComponentsRegistry } from '../../../registry/CommonRegistry';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

const JRCButton = commonComponentsRegistry.getLazyComponent('Button');

export const EditorSave = ({ uniqid, mode }: { uniqid: string; mode: WidgetDisplayMode }) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const wrapper = useAppSelector((state) => Widget.selectors.selectWidget(state, uniqid), shallowEqual);
    const uri = useAppSelector((state) => Widget.selectors.selectWidgetObjectUri(state, uniqid), shallowEqual);

    const handleClick = () => {
        dispatch(WidgetEditor.slice.actions.flushEditor({ uniqid }));
        const content = wrapper && wrapper.widget && wrapper.widget.content;
        if (!uri || !wrapper || !content) return;
        if (mode == 'view') {
            jApi.widget
                .updateWidget<CombinedWidgetContent>({
                    uri,
                    uniqid: uniqid,
                    title: wrapper.title,
                    content: content as CombinedWidgetContent,
                    v2: true,
                })
                .catch((e: any) => {
                    dispatch(
                        Toast.actions.error({
                            label: e.errorMsg ?? intl.formatMessage({ id: 'GLOBAL_Error' }),
                        }),
                    );
                });
        }

        if (mode === 'edit') {
            dispatch(Widget.slice.actions.updateWidget({ uniqid, content: content as CombinedWidgetContent }));
        }
    };

    return (
        <JRCButton color="valid" onClick={handleClick}>
            {intl.formatMessage({ id: 'GLOBAL_Save' })}
        </JRCButton>
    );
};
